import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';

import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';
import { formatPhoneNumber } from '../../utils/formatPhone';
import MaterialSwitch from '../../utils/switch';
import FilledButton from '../FilledButton';
import PushNotificationRegistration from './../profile/PushNotificationRegistration';
import MyFloatingLabelInput from '../form/MyFloatingLabelInput';

import { AppText } from '../AppText';

const styles = StyleSheet.create({
  container: {
    padding: Layout.isSmall ? 16 : 0,
    flex: 1,
    flexDirection: 'column',
  },
  row: {
    flexDirection: 'row',
  },
  inputContainer: {
    marginTop: 28,
    marginLeft: 0,
  },
  inputField: {
    flex: 1,
    paddingLeft: 0,
  },
  stretchRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  leftHalf: {
    marginRight: 16,
  },
  buttonRow: {
    ...Layout.formFooter,
  },
  text: {
    fontSize: 16,
    lineHeight: 24,
    color: Colors.veryDarkGray,
  },
  error: {
    marginTop: 10,
    color: Colors.brightRed,
  },
});

class AdditionalDetailsForm extends Component {
  static propTypes = {
    goNext: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    actions: PropTypes.object,
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    const { registration } = props;
    const { user } = registration;
    let receiveNotifications = true;
    if (user.receive_notifications !== undefined) {
      receiveNotifications = user.receive_notifications;
    }

    this.state = {
      food_pick_up: user.food_pick_up || false,
      pick_up_name: user.pick_up_name || '',
      pick_up_phone: user.pick_up_phone || null,
      receive_notifications: receiveNotifications,
      pushNotificationRegistration: receiveNotifications,
      errors: {},
    };
  }

  validate = (field, value) => {
    switch (field) {
      case 'pick_up_name':
        return value && value !== '' && value.length > 0;
      case 'pick_up_phone':
        return value && value.length === 10;
      default:
        return true;
    }
  };

  setFoodPickup = () => {
    this.setState({ food_pick_up: true });
  };

  removeFoodPickup = () => {
    this.setState({ food_pick_up: false, errors: {} });
  };

  setNotifications = () => {
    this.setState({
      pushNotificationRegistration: true,
      receive_notifications: true,
    });
  };

  removeNotifications = () => {
    this.setState({ receive_notifications: false });
  };

  updateName = (value) => {
    const { translation } = this.props;
    const invalid = translation.app_invalid_error;
    const errorName = translation.fragment_profile_edittext_pickupname;
    const { errors } = this.state;
    if (!this.validate('pick_up_name', value)) {
      errors.pick_up_name = `${invalid} ${errorName}`;
    } else {
      errors.pick_up_name = null;
    }
    this.setState({ errors, pick_up_name: value });
  };

  updatePhone = (value) => {
    const { translation } = this.props;
    const invalid = translation.app_invalid_error;
    const errorPhone = translation.app_personal_edittext_phone;
    const { errors } = this.state;
    const phone = value.replace(/\D/g, '');
    if (!this.validate('pick_up_phone', phone)) {
      errors.pick_up_phone = `${invalid} ${errorPhone}`;
    } else {
      errors.pick_up_phone = null;
    }
    this.setState({ errors, pick_up_phone: phone });
  };

  submitForm = () => {
    const { translation, goNext, registration } = this.props;
    const { user } = registration;
    const labels = {
      invalid: translation.app_invalid_error,
      name: translation.fragment_profile_edittext_pickupname,
      phone: translation.app_personal_edittext_phone,
    };
    const { errors, food_pick_up, pick_up_name, pick_up_phone, receive_notifications } = this.state;
    let formOk = true;
    user.receive_notifications = receive_notifications;
    user.food_pick_up = food_pick_up;
    if (food_pick_up) {
      if (!this.validate('pick_up_name', pick_up_name)) {
        formOk = false;
        errors['pick_up_name'] = `${labels.invalid} ${labels.name}`;
      } else {
        user.pick_up_name = pick_up_name;
      }
      if (!this.validate('pick_up_phone', pick_up_phone)) {
        formOk = false;
        errors['pick_up_phone'] = `${labels.invalid} ${labels.phone}`;
      } else {
        user.pick_up_phone = pick_up_phone;
      }
    }
    if (formOk) {
      return goNext(user);
    }
    this.setState({ errors });
  };

  render() {
    const { translation, goBack, registration, actions } = this.props;
    const {
      errors,
      food_pick_up,
      pick_up_name,
      pick_up_phone,
      receive_notifications,
      pushNotificationRegistration,
    } = this.state;
    const { user } = registration;

    const labels = {
      invalid: translation.app_invalid_error,
      food_pick_up: translation.fragment_profile_switch_pickupfood,
      pick_up_name: translation.fragment_profile_edittext_pickupname,
      pick_up_phone: translation.app_personal_edittext_phone,
      next: translation.fragment_registration_family_button_next,
      back: translation.fragment_registration_family_button_back,
      notifications: translation.fragment_profile_switch_receivenotifications,
    };

    let pushComponent = null;
    if (pushNotificationRegistration) {
      pushComponent = (
        <PushNotificationRegistration user={user} actions={actions} translation={translation} />
      );
    }

    let phoneNumber = pick_up_phone || '';
    if (pick_up_phone && pick_up_phone !== '' && pick_up_phone !== '0') {
      phoneNumber = formatPhoneNumber(pick_up_phone);
    }

    return (
      <View style={styles.container}>
        <View style={styles.topRow}>
          <View style={[styles.row, styles.inputContainer]}>
            <View style={[styles.stretchRow, styles.inputField]}>
              <AppText style={[styles.text, styles.inputField]}>{labels.notifications}</AppText>
              <View>
                <MaterialSwitch
                  onActivate={this.setNotifications}
                  onDeactivate={this.removeNotifications}
                  active={!!receive_notifications}
                  testID="receive-notifications"
                />
              </View>
            </View>
          </View>

          <View style={[styles.row, styles.inputContainer]}>
            <View style={[styles.stretchRow, styles.inputField]}>
              <AppText style={[styles.text, styles.inputField]}>{labels.food_pick_up}</AppText>
              <MaterialSwitch
                onActivate={this.setFoodPickup}
                onDeactivate={this.removeFoodPickup}
                active={!!food_pick_up}
                testID="food-pick-up"
              />
            </View>
          </View>

          <View style={styles.inputContainer}>
            <MyFloatingLabelInput
              label={labels.pick_up_name}
              value={pick_up_name}
              onChangeText={this.updateName}
              width={Layout.isSmall ? 328 : 440}
              error={errors.pick_up_name || ''}
              disabled={!food_pick_up}
              testID="pick-up-name"
            />
          </View>

          <View style={styles.inputContainer}>
            <MyFloatingLabelInput
              label={labels.pick_up_phone}
              value={phoneNumber}
              onChangeText={this.updatePhone}
              onSubmitEditing={this.submitForm}
              width={Layout.isSmall ? 328 : 440}
              error={errors.pick_up_phone || ''}
              disabled={!food_pick_up}
              testID="pick-up-phone"
            />
          </View>
        </View>
        <View style={styles.buttonRow}>
          <View style={[styles.inputField, styles.leftHalf]}>
            <FilledButton
              onPress={goBack}
              label={labels.back}
              color={Colors.darkGreen}
              full={false}
              testID="button-back"
            />
          </View>
          <View style={styles.inputField}>
            <FilledButton
              onPress={this.submitForm}
              label={labels.next}
              color={Colors.darkGreen}
              full
              testID="button-next"
            />
          </View>
        </View>
        {pushComponent}
      </View>
    );
  }
}

export default AdditionalDetailsForm;
